<template>
  <nav class="ui left fixed vertical menu fuzzy-list">
    <Spinny :promise="hubsPromise" :message="$t('READ', { thing: $tc('HUB', 2) })" />
    <Placy
      v-if="!items.length"
      :promise="hubsPromise"
      :empty-message="$t('NO_THING_YET', { thing: $tc('HUB', 2) })"
      :error-message="$t('ERR', { action: $t('READ', { thing: $tc('HUB', 2) }) })"
    />

    <!-- Search -->
    <div class="item" v-if="items.length > 10">
      <div class="ui icon input">
        <input
          type="text"
          :placeholder="$t('SEARCH')"
          v-model="searchTerm"
          autocomplete="off"
          @keydown.esc="searchTerm = ''"
        />
        <i class="search icon"></i>
      </div>
    </div>

    <router-link class="item" :to="{ name: 'new-hub' }">
      <i class="plus icon"></i>
      <strong>{{ $t('CONNECT_TO', { thing: $tc('HUB', 1) }) }}</strong>
    </router-link>

    <router-link
      class="item"
      :active-class="'active'"
      :to="{ name: 'hub', params: { hubId: hub.original.id, tab: 'details' } }"
      v-for="hub in filteredItems"
      :key="hub.original.id"
    >
      <div class="text ellipsis" :title="hub.original.name" v-html="hub.string" />
    </router-link>
  </nav>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

nav {
  overflow-y: scroll;
}
</style>

<script>
// @flow
import { Spinny, Placy } from 'ui'
import { Hub } from 'services'
import FuzzyFilterer from '../Mixins/FuzzyFilterer'

export default {
  name: 'hub-list',
  components: { Spinny, Placy },
  mixins: [FuzzyFilterer],

  data() {
    return {
      hubsPromise: null
    }
  },

  computed: {
    items() {
      return this.$store.state.hub.items
    }
  },

  created() {
    this.hubsPromise = Hub.list()
  }
}
</script>
